
const API_BASE = process.env.VUE_APP_API_BASE || 'https://tyng-ca.com.my'

async function refreshAccessToken () {
  const refreshToken = localStorage.getItem('adminRefreshToken')

  if (!refreshToken) {
    return null
  }

  try {
    const response = await fetch(`${API_BASE}/api/admin/refresh-token.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refresh_token: refreshToken
      })
    })

    const data = await response.json()

    if (data.success && data.token) {
      localStorage.setItem('adminToken', data.token)

      if (data.refresh_token) {
        localStorage.setItem('adminRefreshToken', data.refresh_token)
      }

      return data.token
    }

    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminRefreshToken')

    return null
  } catch (error) {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminRefreshToken')

    return null
  }
}

async function refreshStaffToken () {
  const refreshToken = localStorage.getItem('staffRefreshToken')
  if (!refreshToken) return null
  try {
    const response = await fetch(`${API_BASE}/api/admin/refresh-token.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken })
    })
    const data = await response.json()
    if (data.success && data.token) {
      localStorage.setItem('staffToken', data.token)
      if (data.refresh_token) localStorage.setItem('staffRefreshToken', data.refresh_token)
      return data.token
    }
    localStorage.removeItem('staffToken')
    localStorage.removeItem('staffRefreshToken')
    return null
  } catch {
    localStorage.removeItem('staffToken')
    localStorage.removeItem('staffRefreshToken')
    return null
  }
}

export async function staffFetch (url, options = {}) {
  const fullUrl = url.startsWith('http') ? url : `${API_BASE}${url}`
  const token = localStorage.getItem('staffToken')

  const makeRequest = async (authToken) => {
    return fetch(fullUrl, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        ...(options.headers || {})
      }
    })
  }

  let response = await makeRequest(token)

  if (response.status === 401 && token) {
    const newToken = await refreshStaffToken()
    if (newToken) {
      response = await makeRequest(newToken)
    } else {
      throw new Error('Session expired. Please log in again.')
    }
  }

  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'API request failed')
  return data
}

export async function apiFetch (url, options = {}) {
  const fullUrl = url.startsWith('http')
    ? url
    : `${API_BASE}${url}`

  const token = localStorage.getItem('adminToken')

  const makeRequest = async (authToken) => {
    return fetch(fullUrl, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(authToken
          ? { Authorization: `Bearer ${authToken}` }
          : {}),
        ...(options.headers || {})
      }
    })
  }

  let response = await makeRequest(token)

  // Access token expired → try refresh only for authenticated requests
  const isAdminLoginRequest = fullUrl.includes('/api/admin/login.php')

  if (response.status === 401 && !isAdminLoginRequest && token) {
    const newToken = await refreshAccessToken()

    if (newToken) {
      response = await makeRequest(newToken)
    } else {
      throw new Error('Session expired. Please log in again.')
    }
  }

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data.message || 'API request failed')
  }

  return data
}
